import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderPostResponse, OrderState } from "./types";
import { AddPatientLeadModel } from "../../Services/Models/Order/OrderModel";

const initialState: OrderState = {
  isPlaceOrderSuccess: false,
  isPlaceOrderFailed: false,
  isPlaceOrderInProgress: false,
  isPlaceOrderComplete: false,
  orderLeads: [],
  totalOrderProcessed: 0,
  errorsData: [],
  successData: []
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    addPatientLeadOrder: (state: OrderState, action: PayloadAction<AddPatientLeadModel[]>) => {
      state.orderLeads = action.payload
    },

    setIsPlaceOrderInProgress: (state: OrderState) => {
      state.isPlaceOrderInProgress = true;
    },
    unsetIsPlaceOrderInProgress: (state: OrderState) => {
      state.isPlaceOrderInProgress = false;
    },
    placeOrderStart: (state: OrderState, action: PayloadAction<any>) => {
      state.isPlaceOrderInProgress = true;
    },
    placeOrderCompleteSuccess: (state: OrderState, action: PayloadAction<Pick<OrderPostResponse, "data" | "errors">>) => {
      console.log("action.payload", action.payload);
      //Old Logic
      state.isPlaceOrderInProgress = false;
      state.isPlaceOrderComplete = true;
      state.isPlaceOrderSuccess = true;
      state.totalOrderProcessed = action.payload.data.length;
      state.successData = action.payload.data;
      state.errorsData = action.payload.errors;
    },
    placeOrderCompleteFailed(state: OrderState, action: PayloadAction<Pick<OrderPostResponse, "errors">>) {
      console.log("action.payload error ", action.payload);
      state.isPlaceOrderInProgress = false;
      state.isPlaceOrderComplete = true;
      state.isPlaceOrderFailed = true;
      state.totalOrderProcessed = 0;
      state.successData = [];
      state.errorsData = action.payload.errors;
    },
    placeOrderError: (state: OrderState) => {
      state.isPlaceOrderInProgress = false;
      state.isPlaceOrderComplete = true;
      state.isPlaceOrderFailed = true;
      state.isPlaceOrderSuccess = false;
    },
    resetOrderProcessingStates: (state: OrderState) => {
      state.isPlaceOrderInProgress = false;
      state.isPlaceOrderComplete = false;
      state.isPlaceOrderFailed = false;
      state.isPlaceOrderSuccess = false;
    },
    resetOrderState: (state: OrderState) => {
      state.isPlaceOrderComplete = false;
      state.isPlaceOrderFailed = false;
      state.isPlaceOrderInProgress = false;
      state.isPlaceOrderSuccess = false;
      state.totalOrderProcessed = 0;
      state.orderLeads = [];
      state.successData = [];
      state.errorsData = [];
    }
  }
});

export const orderActions = orderSlice.actions;

// Reducer
const orderReducer = orderSlice.reducer;
export default orderReducer;